export default __webpack_public_path__ + "static/media/qd.d59c0849.svg";